require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-immutable-stateless-react-components.json") })
        }
      }, "path---blog-immutable-stateless-react-components");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-immutable-stateless-react-components!./.cache/json/blog-immutable-stateless-react-components.json
// module id = 886
// module chunks = 231608221292675